import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { constant } from "src/app/common/constant";
import { HelperService } from "src/app/helper/utility/helper.service";
import { RegexEnum } from "src/app/services/enum";
import { HttpRequestsService } from "src/app/services/http-requests.service";

@Component({
  selector: "app-join-team",
  templateUrl: "./join-team.component.html",
  styleUrls: ["./join-team.component.scss"],
})
export class JoinTeamComponent implements OnInit {
  joinTeamForm: FormGroup;
  teamToken: string;
  showPassword = false;
  teamData: any;
  country: any;
  dialingCode: any;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private httprequest: HttpRequestsService,
    private toaster: ToastrService,
    private helper: HelperService,
    private router: Router
  ) {
    this.joinTeamForm = this.fb.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      phoneNumber: [
        "",
        [Validators.required, Validators.pattern(RegexEnum.phonenumber)],
      ],
      dialingCodeId: [1, Validators.required],
      jobTitle: ["", Validators.required],
      password: ["", [Validators.required, Validators.pattern(RegexEnum.passwordValidation)]],
      isDeveloper: [false],
      countryId: [1],
    });
  }

  get formControls() {
    return this.joinTeamForm.controls;
  }

  ngOnInit(): void {
    this.getMetaData();
    this.route.queryParams.subscribe((params) => {
      this.teamToken = params["teamInvitionToken"];

      // Optionally, fetch team or user info based on the token
      this.getTeamMemberDetail();
      
    });
  }
  async getMetaData() {
    const response: any = await this.httprequest.get(
      constant.AUTHROUTE.metaData,
      true
    );
    this.country = response.data.country;
    this.dialingCode = response.data.dialingCode;
    this.joinTeamForm.controls['dialingCodeId'].setValue(this.helper.oneOptionToSelect(this.dialingCode || [],'id'))
    this.joinTeamForm.controls['countryId'].setValue(this.helper.oneOptionToSelect(this.country || [],'id'))
  }

  async getTeamMemberDetail() {
    const result: any = await this.httprequest.get(
      `${constant.APIROUTES.GET_TEAM_MEMBER_DATA_USING_TOKEN}?teamInvitionToken=${this.teamToken}`,
      false
    );
    if (result && result.data && result?.data?.teamUserDetails) {
      this.teamData = result?.data;
      this.joinTeamForm.controls["isDeveloper"].setValue(
        this.teamData?.teamUserDetails?.isDeveloper
      );
    } else {
      this.toaster.error("Your invitation join link has expired.");
    }
  }

  async onSubmit(event) {
    event.preventDefault();
    console.log(this.joinTeamForm.value);
    let response;
    if (this.joinTeamForm.valid) {
      this.httprequest.showLoading();
      const formData = {
        ...this.joinTeamForm.value,
        teamInvitionToken: this.teamToken,
        businessId: this.teamData?.teamDetails?.businessId,
        teamId: this.teamData?.teamDetails?.id,
        userId: this.teamData?.teamDetails?.userId,
      };

      response = await this.httprequest.post(
        constant.APIROUTES.JOIN_TEAM,
        formData,
        true
      );
    }
    this.httprequest.hideLoading();
    if (response) {
      this.helper.showSuccessToast(response?.body?.message);
      this.router.navigate(["auth/login"]);
      this.joinTeamForm.reset();
    } else {
      this.helper.showErrorToast(response.error);
    }
  }

  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
